// /app/frontend/src/lib/adminApi.js
//
// Thin API client for the Admin Panel. Kept isolated so the panel can
// grow (moderation, user search, reports) without touching lib/api.js.
// The backend is the real security gate — this file only enforces the
// UI contract (no client-side "trust me" flags).

import api from "./api";

export async function fetchAdminStats() {
  const { data } = await api.get("/admin/stats");
  return data; // {as_of, total_users, new_today, new_this_week, new_this_month}
}

export async function fetchAdminRecentUsers({ limit = 20 } = {}) {
  const { data } = await api.get(`/admin/recent-users?limit=${limit}`);
  return data?.items || [];
}

// ---------- Content moderation ----------
// Admin-only delete helpers. Backend enforces the `require_admin` gate;
// these are just convenience wrappers so pages don't hard-code paths.

export async function adminDeletePost(postId) {
  const { data } = await api.delete(`/admin/posts/${postId}`);
  return data; // {deleted, post_id, comments_removed}
}

export async function adminDeleteComment(commentId) {
  const { data } = await api.delete(`/admin/comments/${commentId}`);
  return data; // {deleted, comment_id}
}

// ---------- Account management ----------
// Admin-only user list (searchable + paginated) and permanent delete.
// Delete cascades all data owned by the target across MongoDB — same
// cascade as the user's own /account delete. Refuses to target admins
// or the caller themselves (server-enforced).

export async function fetchAdminUsers({ q = "", skip = 0, limit = 20 } = {}) {
  const params = new URLSearchParams();
  if (q && q.trim()) params.set("q", q.trim());
  params.set("skip", String(skip));
  params.set("limit", String(limit));
  const { data } = await api.get(`/admin/users?${params.toString()}`);
  return data; // {items, total, skip, limit}
}

export async function adminDeleteUser(userId) {
  const { data } = await api.delete(`/admin/users/${userId}`);
  return data; // {user_id, ok, deleted: {collection: count}, errors: {...}}
}
